<div class="card card-nc esign_box ">
  <div class="container">
    <div class="col-12">
      <div style="width: 80%; margin: 0 auto;">
        <app-progress-bar
          [whichStep]="3"
          [sectionsArray]="tabs"
        ></app-progress-bar>
      </div>
    </div>
  </div>
  <br />
  <div class="enrollHeading">
    Service & Terms
  </div>
    <div class="row">
    <div class="col-md-12">
      <div class="card card-nc subEnroll">
        <div class="card-body enroll">
          <app-terms-short-pdf></app-terms-short-pdf>
          <br />
          <a href="../assets/navy_cash_short_form_2023.pdf" target="_blank" download
            >Download</a
          >
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-nc subEnroll">
        <div class="card-body enroll">
          <app-terms-pdf></app-terms-pdf>
          <br />
          <a href="../assets/navycash-tcs.pdf" target="_blank" download
            >Download</a
          >
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-nc subEnroll">
        <div class="card-body enroll">
          <app-terms-long-pdf></app-terms-long-pdf>
          <br />
          <a href="../assets/navy_cash_long_form_2023.pdf" target="_blank" download
            >Download</a
          >
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-nc subEnroll">
        <div class="card-body enroll">
          <div class="enrollHelpTitle">
            <br />
            <div class="checkbox">
              <label>
                <b>
                <input type="checkbox" [(ngModel)]="agree" value="true" />
                I agree to the
                "<a href="../assets/navy_cash_short_form_2023.pdf" target="_blank" download>Navy Cash&reg; Card</a>",
                "<a href="../assets/navycash-tcs.pdf" target="_blank" download>Navy Cash Card&reg; and Navy Cash&reg; Visitor Card Cardholder Agreements</a>",
                  and "<a href="../assets/navy_cash_long_form_2023.pdf" target="_blank" download>All Fees for Navy Cash&reg; Open Loop/Card</a>".</b>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <button
        id="enroll_button"
        name="terms_button"
        [disabled]="!agree"
        type="button"
        class="btn btn-block pull-right"
        (click)="next()"
      >
        I Agree
      </button>
    </div>
  </div>
</div>
